import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

Vue.use(Router)

const routes = [
  { path: '/login', component: () => import('@/views/Login') },
  {
    path: '/',
    redirect: '/home',
    meta: { requireAuth: true }
  },
  {
    path: '/home',
    component: () => import('@/views/Home'),
    meta: { requireAuth: true }
  },
  {
    path: '/theme',
    component: () => import('@/views/Theme'),
    meta: { requireAuth: true }
  }
]

const router = new Router({
  mode: 'hash',
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth && !store.getters.token) {
    next('/login')
  } else {
    next()
  }
})

export default router